import React from 'react'
import AutoTooltipContent from './AutoTooltipContent'
import styled from 'styled-components'

const TooltipContent = styled(AutoTooltipContent)``

export const TooltipTrigger = styled.span`
  cursor: pointer;
  &:hover + ${TooltipContent} {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
    transition: opacity 0.2s 0.3s;
  }
`

const AutoTooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`

interface State {
  open: boolean;
}

interface Props {
  className?: string;
  onOpen?: () => void;
  /* Must have tooltip content, pointless without it */
  children: React.ReactNode;
}

/**
 * Tooltips around the children passed in.
 * The first child passed in will be the tooltip trigger
 * The second child will be the tooltip content
 * All other children will be ignored
 * defaults to appearing above, no smart positioning though unfortunately
 */
class AutoTooltip extends React.Component<React.PropsWithChildren<Props>, State> {
  state: State = {
    open: false,
  }

  static defaultProps = {
    position: 'above',
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick)
  }

  onWindowClick = () => {
    if (this.state.open) {
      this.setState({ open: false })
    }
  }

  toggle = (e: React.SyntheticEvent<any>) => {
    e.preventDefault()
    if (!this.state.open) {
      this.props.onOpen?.()
      e.stopPropagation()
      window.addEventListener('click', this.onWindowClick)
    } else {
      window.removeEventListener('click', this.onWindowClick)
    }

    this.setState(prevState => ({
      open: !prevState.open,
    }))
  }

  render() {
    const { children, className } = this.props
    const { open } = this.state
    const [triggerElement, contentElement] = React.Children.toArray(children)
    const contentProps = (contentElement && (contentElement as React.ReactElement).props) || {}

    return (
      <AutoTooltipContainer className={className} onClick={this.toggle}>
        <TooltipTrigger>{triggerElement}</TooltipTrigger>
        <TooltipContent
          {...contentProps}
          open={open}
        />
      </AutoTooltipContainer>
    )
  }
}

export default AutoTooltip
